import {first} from 'rxjs/operators';
import {MatDialogRef} from '@angular/material/dialog';
import {Component} from '@angular/core';
import {CacheService} from '../../cache/cache.service';
import {LanguageService} from '../../language/language.service';

@Component({
  selector: 'error-dialog',
  template: `
    <app-dialog>
      <app-dialog-title>{{ title }}</app-dialog-title>
      <div mat-dialog-content>
        <p class="message">{{ message }}</p>
        @if (details) {
          <p>
            @if (!showDetails) {
              <a (click)="showDetails = true" class="showDetailsLink">
                <language key="ErrorDialogShowDetails" defaultValue="Show Details"></language>
              </a>
            }
            @if (showDetails) {
              <a (click)="showDetails = false" class="showDetailsLink">
                <language key="ErrorDialogHideDetails" defaultValue="Hide Details"></language>
              </a>
            }
          </p>
        }
        <pre class="details" [hidden]="!showDetails">{{ details }}</pre>
      </div>
      <app-dialog-action-button [primary]="true" (click)="dialogRef.close(true)">
        {{ labelDisplay }}
      </app-dialog-action-button>
    </app-dialog>
  `,
  styleUrls: ['./error-dialog.component.scss'],
  standalone: false,
})
export class ErrorDialog {
  public title: string;
  public message: string;
  public details: string;
  public label: string = null;

  showDetails: boolean = false;

  get labelDisplay(): string {
    return this.label ? this.label : 'OK';
  }

  constructor(
    public dialogRef: MatDialogRef<ErrorDialog>,
    cacheService: CacheService,
  ) {
    if (this.label == null) {
      cacheService
        .getLanguageResource()
        .pipe(first())
        .subscribe(lr => {
          if (this.label == null) {
            this.label = LanguageService.translate('OK', 'OK', lr);
          }
        });
    }
  }
}
